﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Button, Popover, PopoverInteractionKind } from "@blueprintjs/core";
import 'components/listing/Listing.css';

export function ListingPagination(
    {
        totalPages = 1,
        currentPage = 1,
        loadingData = true,
        className = "",
        itemName = "Page",
        pagingListPosition = "auto",
        onPageChange
    }
) {

    let pagesToShow = 3;
    let showPageSelector = true;

    if (totalPages < pagesToShow) {
        pagesToShow = totalPages;
        showPageSelector = false;
    }

    let startPage = currentPage - Math.floor(pagesToShow / 2);

    if (startPage < 1) {
        startPage = 1;
    } else if (startPage + pagesToShow > totalPages) {
        startPage = totalPages - (pagesToShow - 1);
    }

    const items = [];
    const listItems = [];

    for (let i = 0; i < pagesToShow; i++) {

        let page = startPage + i;

        items.push(<Button key={i} className={classNames({
            active: (page === currentPage)
        })} text={page} variant="minimal" size="large" disabled={loadingData} onClick={() => {
            onPageChangeValue(page)
        }}></Button>)
    }

    for (let i = 1; i <= totalPages; i++) {
        listItems.push(<Button key={i} variant="minimal" className="bp6-popover-dismiss" onClick={() => {
            onPageChangeValue(i)
        }}>{itemName} {i}</Button>);
    }

    function onPageChangeValue (pageNumber) {
        onPageChange(pageNumber);
    }

    function gotoNextPage() {
        onPageChangeValue(currentPage + 1);
    }

    function gotoPreviousPage() {
        onPageChangeValue(currentPage - 1);
    }

    return (
        <div className={classNames("pagination", className)}>
            <Button icon="chevron-left" disabled={currentPage === 1 || loadingData} variant="minimal" size="large" onClick={gotoPreviousPage}></Button>
            {items}
            <Button icon="chevron-right" disabled={currentPage === totalPages || loadingData} variant="minimal" size="large" onClick={gotoNextPage}></Button>
            {showPageSelector ?
                <Popover
                    disabled={loadingData}
                    position={pagingListPosition}
                    interactionKind={PopoverInteractionKind.CLICK}
                    popoverClassName="pagination-page-select"
                    minimal={true}
                    content={<div>{listItems}</div>}
                >
                    <Button variant="minimal" size="large" icon="layout-linear" disabled={loadingData}></Button>
                </Popover> : null}
        </div>
    );

}

ListingPagination.propTypes = {
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    loadingData: PropTypes.bool,
    onPageChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    itemName: PropTypes.string,
    pagingListPosition: PropTypes.string
};